import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import Modal from "../components/Modals/Modal";
import ContactPopupModal from "../components/Modals/ContactPopupModal";

const ContactModalContext = createContext();

export const ContactModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const timerRef = useRef(null);

  const showContactPopUp = () => {
    // If already open, do nothing
    if (isModalOpen) return;

    // Cancel the 60s auto-timer since user opened it manually
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    setIsModalOpen(true);
  };

  useEffect(() => {
    // Start the 60s auto-timer on page load
    timerRef.current = setTimeout(() => {
      setIsModalOpen((prev) => {
        // Only open if not already opened manually
        if (!prev) return true;
        return prev;
      });
    }, 60000);

    return () => {
      // Cleanup timer on unmount
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <ContactModalContext.Provider value={{ showContactPopUp }}>
      {children}

      {/* Single Modal instance for the entire app */}
      {isModalOpen && (
        <Modal setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen}>
          <ContactPopupModal setIsModalOpen={setIsModalOpen} />
        </Modal>
      )}
    </ContactModalContext.Provider>
  );
};

// Custom hook for easy access
export const useContactModal = () => {
  const context = useContext(ContactModalContext);
  if (!context) {
    throw new Error("useContactModal must be used within a ContactModalProvider");
  }
  return context;
};